import initialState from './initialState';
import {ENABLE_LOADING, DISABLE_LOADING} from '../actions/LoadingActions';

export default function LoadingReducer(state = initialState.loading, action) {
    switch (action.type) {
        case ENABLE_LOADING:
            return action.payload; // true - coming from enableLoading redux action
        case DISABLE_LOADING:
            return action.payload; // false - coming from disbaleLoading redux action
        default:
            return state;
    }
}